import { useState } from "react";
import { Modal, Table, Button, Space, Typography } from "antd";

export default function ModalJOItems({ show, close, joItems = [], onConfirm }) {
  const [selectedKeys, setSelectedKeys] = useState([]);

  const handleConfirm = () => {
    const selected = joItems.filter((item) => selectedKeys.includes(item.pg_code));
    onConfirm(selected);
  };

  const columns = [
    {
      title: "รหัสสินค้า",
      dataIndex: "pg_code",
      key: "pg_code",
      width: 130,
    },
    {
      title: "รายการสินค้า",
      dataIndex: "pg_name",
      key: "pg_name",
    },
    {
      title: "จำนวน/กล่อง",
      dataIndex: "carton",
      key: "carton",
      width: 130,
      align: "right",
      render: (v) => Number(v || 0).toLocaleString(),
    },
  ];

  return (
    <Modal
      open={show}
      title="เลือกรายการสินค้าจาก Job Order"
      onCancel={close}
      maskClosable={false}
      style={{ top: 20 }}
      width={700}
      footer={
        <Space>
          <Button onClick={close}>ยกเลิก</Button>
          <Button
            type="primary"
            disabled={selectedKeys.length === 0}
            onClick={handleConfirm}
          >
            เพิ่มรายการที่เลือก ({selectedKeys.length})
          </Button>
        </Space>
      }
    >
      <Typography.Text type="secondary" style={{ display: "block", marginBottom: 12 }}>
        เลือกรายการที่ต้องการเพิ่มในใบส่งมอบ
      </Typography.Text>
      <Table
        size="small"
        rowKey="pg_code"
        columns={columns}
        dataSource={joItems}
        pagination={false}
        scroll={{ y: 400 }}
        rowSelection={{
          selectedRowKeys: selectedKeys,
          onChange: (keys) => setSelectedKeys(keys),
        }}
      />
    </Modal>
  );
}
